//define each api like getSomething() here
import { get, post } from "./utils";
import * as customError from "../utils/errorHandler";

export const getToken = async () => {
	try {
		return await get(`${process.env.REACT_APP_API_URL}/Token`);
	} catch (error) {
		customError.throwCustomError(error, customError.TOKEN_ERROR_MESSAGE);
	}
};

export const getUserPermissionByAppId = async (data) => {
	try {
		const { appId, userId } = data;

		return await get(
			`${
				process.env.REACT_APP_API_URL
			}/User/GetUserPermissionByAppId/${appId}/${userId ? userId : ""}`
		);
	} catch (error) {
		customError.throwCustomError(error, customError.GENERIC_ERROR_MESSAGE);
	}
};

export const searchByName = async (data) => {
	try {
		const { name, appHierarchyId } = data;

		return await get(
			`${process.env.REACT_APP_API_URL}/User/SearchByName/${name}/${
				appHierarchyId ? appHierarchyId : "null"
			}`
		);
	} catch (error) {
		customError.throwCustomError(error, customError.GENERIC_ERROR_MESSAGE);
	}
};

export const searchByNameAd = async (data) => {
	try {
		const { name } = data;

		return await get(
			`${process.env.REACT_APP_API_URL}/User/GetAdUsersByName/${name}`
		);
	} catch (error) {
		customError.throwCustomError(error, customError.GENERIC_ERROR_MESSAGE);
	}
};

export const getOrAddCapexUserByEmail = async (data) => {
	try {
		const { email } = data;

		return await get(
			`${process.env.REACT_APP_API_URL}/User/GetOrAddCapexUserByEmail/${email}`
		);
	} catch (error) {
		customError.throwCustomError(error, customError.GENERIC_ERROR_MESSAGE);
	}
};

export const searchByPersonId = async (data) => {
	try {
		const { personId } = data;

		return await get(
			`${process.env.REACT_APP_API_URL}/User/SearchByPersonId/${personId}`
		);
	} catch (error) {
		customError.throwCustomError(error, customError.GENERIC_ERROR_MESSAGE);
	}
};

//deepsearch -1, get ancestors
export const getUsersByOrgHierarchy = async (data) => {
	try {
		const {
			organisationHierarchyId,
			domain,
			deepSearch,
			includeNewUser,
			appId,
		} = data;

		return await get(
			`${
				process.env.REACT_APP_API_URL
			}/User/GetUsersByOrgHierarchy/${domain}/${
				organisationHierarchyId
					? organisationHierarchyId
					: "00000000-0000-0000-0000-000000000000"
			}/${deepSearch ? deepSearch : false}/${
				includeNewUser ? includeNewUser : false
			}/${appId ? appId : "00000000-0000-0000-0000-000000000000"}`
		);
	} catch (error) {
		customError.throwCustomError(error, customError.GENERIC_ERROR_MESSAGE);
	}
};

export const postUser = async (data) => {
	try {
		return await post(`${process.env.REACT_APP_API_URL}/User`, data);
	} catch (error) {
		customError.throwCustomError(
			error,
			customError.GENERIC_POST_ERROR_MESSAGE
		);
	}
};

export const postUserApp = async (data) => {
	try {
		return await post(`${process.env.REACT_APP_API_URL}/UserApp`, data);
	} catch (error) {
		customError.throwCustomError(
			error,
			customError.GENERIC_POST_ERROR_MESSAGE
		);
	}
};

export const postUserRole = async (data) => {
	try {
		return await post(`${process.env.REACT_APP_API_URL}/UserRole`, data);
	} catch (error) {
		customError.throwCustomError(
			error,
			customError.GENERIC_POST_ERROR_MESSAGE
		);
	}
};

export const getUserRolesByUserIdAndAppId = async (data) => {
	try {
		return await get(
			`${process.env.REACT_APP_API_URL}/UserRole/GetByUserIdAndAppId/${
				data.userId
			}/${data.appId ? data.appId : ""}`
		);
	} catch (error) {
		customError.throwCustomError(error, customError.FORMS_ERROR_MESSAGE);
	}
};
export const getUserRolesByUserIdAndAppIdHistory = async (data) => {
	try {
		return await get(
			`${
				process.env.REACT_APP_API_URL
			}/UserRole/GetByUserIdAndAppIdHistory/${data.userId}/${
				data.appId ? data.appId : ""
			}`
		);
	} catch (error) {
		customError.throwCustomError(error, customError.FORMS_ERROR_MESSAGE);
	}
};

export const getAppRolesByAppId = async (data) => {
	try {
		return await get(
			`${process.env.REACT_APP_API_URL}/AppRole/GetByAppId/${
				data.appId ? data.appId : ""
			}`
		);
	} catch (error) {
		customError.throwCustomError(error, customError.FORMS_ERROR_MESSAGE);
	}
};

export const getForms = async (appId, filter) => {
	try {
		return await get(
			`${process.env.REACT_APP_API_URL}/ResponseForm/GetForms?appId=${appId}&filter=${filter}`
		);
	} catch (error) {
		customError.throwCustomError(error, customError.FORMS_ERROR_MESSAGE);
	}
};

export const getFormById = async (data) => {
	try {
		return await get(
			`${process.env.REACT_APP_API_URL}/ResponseForm/${data.formId}`
		);
	} catch (error) {
		customError.throwCustomError(
			error,
			customError.FORM_BY_ID_ERROR_MESSAGE
		);
	}
};

export const getFormDefinitionById = async (data) => {
	try {
		return await get(
			`${process.env.REACT_APP_API_URL}/FormDefinition/${data.formDefinitionId}`
		);
	} catch (error) {
		customError.throwCustomError(
			error,
			customError.FORMDEFINITION_BY_ID_ERROR_MESSAGE
		);
	}
};

export const getAttachmentById = async (data) => {
	try {
		return await get(
			`${process.env.REACT_APP_API_URL}/UploadDocument/GetUploadDocument/${data.attachmentId}`,
			[{ key: "respnseType", value: "arraybuffer" }]
		);
	} catch (error) {
		customError.throwCustomError(
			error,
			customError.ATTACHMENT_BY_ID_ERROR_MESSAGE
		);
	}
};

export const getUploadDocuments = async (data) => {
	try {
		return await get(
			`${process.env.REACT_APP_API_URL}/UploadDocument/GetUploadDocuments/${data.formId}`
		);
	} catch (error) {
		customError.throwCustomError(
			error,
			customError.UPLOAD_DOCUMENTS_ERROR_MESSAGE
		);
	}
};

export const getWorkflowsByFormId = async (data) => {
	try {
		return await get(
			`${process.env.REACT_APP_API_URL}/Workflow/${data.responseFormId}`
		);
	} catch (error) {
		customError.throwCustomError(
			error,
			customError.WORKFLOWS_BY_FORMID_ERROR_MESSAGE
		);
	}
};

export const getWorkflowHistoryByFormId = async (data) => {
	try {
		return await get(
			`${process.env.REACT_APP_API_URL}/WorkflowHistory/${data.responseFormId}`
		);
	} catch (error) {
		customError.throwCustomError(
			error,
			customError.WORKFLOWS_BY_FORMID_ERROR_MESSAGE
		);
	}
};

export const postWorkflowHistory = async (data) => {
	try {
		return await post(
			`${process.env.REACT_APP_API_URL}/WorkflowHistory`,
			data
		);
	} catch (error) {
		customError.throwCustomError(
			error,
			customError.GENERIC_POST_ERROR_MESSAGE
		);
	}
};

export const postFormDefinition = async (data) => {
	try {
		return await post(
			`${process.env.REACT_APP_API_URL}/FormDefinition`,
			data
		);
	} catch (error) {
		customError.throwCustomError(
			error,
			customError.POST_FORMDEFINITION_ERROR_MESSAGE
		);
	}
};

export const postResponseForm = async (data) => {
	try {
		return await post(
			`${process.env.REACT_APP_API_URL}/ResponseForm`,
			data
		);
	} catch (error) {
		customError.throwCustomError(
			error,
			customError.POST_RESPONSEFORM_ERROR_MESSAGE
		);
	}
};

export const uploadDocument = async (data) => {
	try {
		return await post(
			`${process.env.REACT_APP_API_URL}/UploadDocument/UploadDocument`,
			data
		);
	} catch (error) {
		customError.throwCustomError(
			error,
			customError.UPLOAD_DOCUMENT_ERROR_MESSAGE
		);
	}
};

export const uploadRoC = async (data) => {
	try {
		return await post(
			`${process.env.REACT_APP_API_URL}/UploadDocument/UploadRoC`,
			data
		);
	} catch (error) {
		customError.throwCustomError(
			error,
			customError.UPLOAD_DOCUMENT_ERROR_MESSAGE
		);
	}
};

export const deleteUploadDocument = async (data) => {
	try {
		return await post(
			`${process.env.REACT_APP_API_URL}/UploadDocument/Delete`,
			data
		);
	} catch (error) {
		customError.throwCustomError(
			error,
			customError.GENERIC_POST_ERROR_MESSAGE
		);
	}
};

export const submitWorkflow = async (data, comment = "") => {
	try {
		return await post(`${process.env.REACT_APP_API_URL}/Workflow`, {
			workflowDtos: data,
			action: "Submit",
			comment: comment,
		});
	} catch (error) {
		customError.throwCustomError(
			error,
			customError.SUBMIT_WORKFLOW_ERROR_MESSGE
		);
	}
};

export const getWorkflowApprovers = async (data) => {
	try {
		const { roleId, organisationId, domain } = data;
		return await get(
			`${
				process.env.REACT_APP_API_URL
			}/Workflow/GetApprovers?domain=${domain}${
				organisationId ? "&organisationId=" + organisationId : ""
			}${roleId ? "&roleId=" + roleId : ""}`
		);
	} catch (error) {
		customError.throwCustomError(error, customError.GENERIC_ERROR_MESSAGE);
	}
};

export const resumeWorkflow = async (data, comment = "") => {
	try {
		return await post(`${process.env.REACT_APP_API_URL}/Workflow`, {
			workflowDtos: data,
			action: "Resume",
			comment: comment,
		});
	} catch (error) {
		customError.throwCustomError(
			error,
			customError.RESUME_WORKFLOW_ERROR_MESSAGE
		);
	}
};

export const delegateWorkflow = async (data, delegateUserId, comment = "") => {
	try {
		return await post(
			`${process.env.REACT_APP_API_URL}/Workflow/WorkflowAction`,
			{
				workflowDto: data,
				action: "Delegate",
				delegatedUserId: delegateUserId,
				comment: comment,
			}
		);
	} catch (error) {
		customError.throwCustomError(
			error,
			customError.UPSERT_WORKFLOW_ERROR_MESSAGE
		);
	}
};

export const queryWorkflow = async (data, delegateUserId, comment = "") => {
	try {
		return await post(
			`${process.env.REACT_APP_API_URL}/Workflow/WorkflowAction`,
			{
				workflowDto: data,
				action: "Query",
				delegatedUserId: delegateUserId,
				comment: comment,
			}
		);
	} catch (error) {
		customError.throwCustomError(
			error,
			customError.UPSERT_WORKFLOW_ERROR_MESSAGE
		);
	}
};

export const approveWorkflow = async (data, comment = "") => {
	try {
		return await post(
			`${process.env.REACT_APP_API_URL}/Workflow/WorkflowAction`,
			{
				workflowDto: data,
				action: "Approve",
				comment: comment,
			}
		);
	} catch (error) {
		customError.throwCustomError(
			error,
			customError.APPROVE_WORKFLOW_ERROR_MESSAGE
		);
	}
};

export const respondWorkflow = async (data, comment = "") => {
	try {
		return await post(
			`${process.env.REACT_APP_API_URL}/Workflow/WorkflowAction`,
			{
				workflowDto: data,
				action: "Respond",
				comment: comment,
			}
		);
	} catch (error) {
		customError.throwCustomError(
			error,
			customError.APPROVE_WORKFLOW_ERROR_MESSAGE
		);
	}
};

export const declineWorkflow = async (data, comment = "") => {
	try {
		return await post(
			`${process.env.REACT_APP_API_URL}/Workflow/WorkflowAction`,
			{
				workflowDto: data,
				action: "Decline",
				comment: comment,
			}
		);
	} catch (error) {
		customError.throwCustomError(
			error,
			customError.DECLINE_WORKFLOW_ERROR_MESSAGE
		);
	}
};

export const addWorkflow = async (data, comment = "") => {
	try {
		return await post(
			`${process.env.REACT_APP_API_URL}/Workflow/WorkflowAction`,
			{
				workflowDto: data,
				action: "Add",
				comment: comment,
			}
		);
	} catch (error) {
		customError.throwCustomError(
			error,
			customError.UPSERT_WORKFLOW_ERROR_MESSAGE
		);
	}
};

export const editWorkflow = async (data, comment = "") => {
	try {
		return await post(
			`${process.env.REACT_APP_API_URL}/Workflow/WorkflowAction`,
			{
				workflowDto: data,
				action: "Change",
				comment: comment,
			}
		);
	} catch (error) {
		customError.throwCustomError(
			error,
			customError.UPSERT_WORKFLOW_ERROR_MESSAGE
		);
	}
};

export const deleteWorkflow = async (data, comment = "") => {
	try {
		return await post(
			`${process.env.REACT_APP_API_URL}/Workflow/WorkflowAction`,
			{
				workflowDto: data,
				action: "Delete",
				comment: comment,
			}
		);
	} catch (error) {
		customError.throwCustomError(
			error,
			customError.UPSERT_WORKFLOW_ERROR_MESSAGE
		);
	}
};

export const resendPayrollEmail = async (data, comment = "") => {
	try {
		return await post(
			`${process.env.REACT_APP_API_URL}/Workflow/WorkflowAction`,
			{
				workflowDto: data,
				action: "ResendPayrollEmail",
				comment: comment,
			}
		);
	} catch (error) {
		customError.throwCustomError(
			error,
			customError.UPSERT_WORKFLOW_ERROR_MESSAGE
		);
	}
};

export const deleteWorkflowsByResponseFormId = async ({ responseFormId }) => {
	try {
		return await post(
			`${process.env.REACT_APP_API_URL}/Workflow/DeleteWorkflows/${responseFormId}`,
			null
		);
	} catch (error) {
		customError.throwCustomError(
			error,
			customError.UPSERT_WORKFLOW_ERROR_MESSAGE
		);
	}
};

export const getWorkflowsByTemplate = async (data) => {
	try {
		return await post(
			`${process.env.REACT_APP_API_URL}/Workflow/PopulateWorkflows`,
			data
		);
	} catch (error) {
		customError.throwCustomError(error, customError.GENERIC_ERROR_MESSAGE);
	}
};

export const getTreeById = async (data) => {
	try {
		const { id } = data;
		return await get(
			`${process.env.REACT_APP_API_URL}/Hierarchy/GetById?id=${id}`
		);
	} catch (error) {
		customError.throwCustomError(
			error,
			customError.TREE_BY_DOMAIN_ERROR_MESSAGE
		);
	}
};

export const getTreeByDomain = async (data) => {
	try {
		const { domain, parentId, allowAllSelect, hideChildren } = data;
		return await get(
			`${process.env.REACT_APP_API_URL}/Hierarchy?domain=${domain}${
				parentId ? "&parentId=" + parentId : ""
			}${allowAllSelect ? "&allowAllSelect=true" : ""}
			${hideChildren ? "&hideChildren=true" : ""}`
		);
	} catch (error) {
		customError.throwCustomError(
			error,
			customError.TREE_BY_DOMAIN_ERROR_MESSAGE
		);
	}
};

export const getChildrenByDomain = async (data) => {
	try {
		const { domain } = data;
		return await get(
			`${process.env.REACT_APP_API_URL}/Hierarchy/GetChildrenByDomain/${domain}`
		);
	} catch (error) {
		customError.throwCustomError(error, customError.GENERIC_ERROR_MESSAGE);
	}
};

export const getHierarchies = async (data) => {
	try {
		return await post(
			`${process.env.REACT_APP_API_URL}/Hierarchy/GetHierarchies`,
			data
		);
	} catch (error) {
		customError.throwCustomError(
			error,
			customError.GENERIC_POST_ERROR_MESSAGE
		);
	}
};

export const postHierarchy = async (data) => {
	try {
		return await post(`${process.env.REACT_APP_API_URL}/Hierarchy`, data);
	} catch (error) {
		customError.throwCustomError(
			error,
			customError.GENERIC_POST_ERROR_MESSAGE
		);
	}
};

export const getDelegateUserById = async (data) => {
	try {
		const { id } = data;
		return await get(`${process.env.REACT_APP_API_URL}/DelegateUser/${id}`);
	} catch (error) {
		customError.throwCustomError(error, customError.GENERIC_ERROR_MESSAGE);
	}
};

export const getDelegateUserByUserId = async (data) => {
	try {
		const { userId } = data;
		return await get(
			`${process.env.REACT_APP_API_URL}/DelegateUser/GetByUserId/${userId}?onlyActive=false`
		);
	} catch (error) {
		customError.throwCustomError(error, customError.GENERIC_ERROR_MESSAGE);
	}
};

export const getDelegateUserByForUserId = async (data) => {
	try {
		const { forUserId } = data;
		return await get(
			`${process.env.REACT_APP_API_URL}/DelegateUser/GetByForUserId/${forUserId}?onlyActive=false`
		);
	} catch (error) {
		customError.throwCustomError(error, customError.GENERIC_ERROR_MESSAGE);
	}
};

export const postDelegateUser = async (data) => {
	try {
		return await post(
			`${process.env.REACT_APP_API_URL}/DelegateUser`,
			data
		);
	} catch (error) {
		customError.throwCustomError(
			error,
			customError.GENERIC_POST_ERROR_MESSAGE
		);
	}
};

//CME apis
export const getCMEFormById = async (data) => {
	try {
		const { id } = data;
		return await get(
			`${process.env.REACT_APP_API_URL}/CME/Form/GetByFormGuid/${id}`
		);
	} catch (error) {
		customError.throwCustomError(
			error,
			customError.FORM_BY_ID_ERROR_MESSAGE
		);
	}
};

export const getCPEFormById = async (data) => {
	try {
		const { id, formId } = data;
		if (id) {
			return await get(
				`${process.env.REACT_APP_API_URL}/CME/CPEForm/${id}`
			);
		} else {
			return await get(
				`${process.env.REACT_APP_API_URL}/CME/CPEForm/byFormId/${formId}`
			);
		}
	} catch (error) {
		customError.throwCustomError(
			error,
			customError.FORM_BY_ID_ERROR_MESSAGE
		);
	}
};

export const postCPEForm = async (data) => {
	try {
		return await post(`${process.env.REACT_APP_API_URL}/CME/CPEForm`, data);
	} catch (error) {
		customError.throwCustomError(
			error,
			customError.POST_RESPONSEFORM_ERROR_MESSAGE
		);
	}
};

export const getRequestFormById = async (data) => {
	try {
		const { id, formId } = data;

		if (id) {
			return await get(
				`${process.env.REACT_APP_API_URL}/CME/RequestForm/${id}`
			);
		} else {
			return await get(
				`${process.env.REACT_APP_API_URL}/CME/RequestForm/byFormId/${formId}`
			);
		}
	} catch (error) {
		customError.throwCustomError(
			error,
			customError.FORM_BY_ID_ERROR_MESSAGE
		);
	}
};

export const postRequestForm = async (data) => {
	try {
		return await post(
			`${process.env.REACT_APP_API_URL}/CME/RequestForm`,
			data
		);
	} catch (error) {
		customError.throwCustomError(
			error,
			customError.POST_RESPONSEFORM_ERROR_MESSAGE
		);
	}
};

export const saveByPayroll = async (data) => {
	try {
		return await post(
			`${process.env.REACT_APP_API_URL}/CME/RequestForm/SaveByPayroll`,
			data
		);
	} catch (error) {
		customError.throwCustomError(
			error,
			customError.POST_RESPONSEFORM_ERROR_MESSAGE
		);
	}
};

export const saveByPayrollCpe = async (data) => {
	try {
		return await post(
			`${process.env.REACT_APP_API_URL}/CME/RequestForm/SaveByPayrollCpe`,
			data
		);
	} catch (error) {
		customError.throwCustomError(
			error,
			customError.POST_RESPONSEFORM_ERROR_MESSAGE
		);
	}
};

export const getAttachmentsByFormId = async (data) => {
	try {
		return await get(
			`${process.env.REACT_APP_API_URL}/CME/Attachment/${data.formId}`
		);
	} catch (error) {
		customError.throwCustomError(error, customError.GENERIC_ERROR_MESSAGE);
	}
};

export const getCMEAttachmentById = async (data) => {
	try {
		return await get(
			`${process.env.REACT_APP_API_URL}/CME/Attachment/Download/${data.attachmentId}`,
			[{ key: "respnseType", value: "arraybuffer" }]
		);
	} catch (error) {
		customError.throwCustomError(
			error,
			customError.ATTACHMENT_BY_ID_ERROR_MESSAGE
		);
	}
};

export const postAttachment = async (data) => {
	try {
		return await post(
			`${process.env.REACT_APP_API_URL}/CME/Attachment`,
			data
		);
	} catch (error) {
		customError.throwCustomError(
			error,
			customError.UPLOAD_DOCUMENT_ERROR_MESSAGE
		);
	}
};

export const getLeaveLinesByFormId = async (data) => {
	try {
		return await get(
			`${process.env.REACT_APP_API_URL}/CME/LeaveLine/${data.formId}`
		);
	} catch (error) {
		customError.throwCustomError(error, customError.GENERIC_ERROR_MESSAGE);
	}
};

export const postLeaveLines = async (data) => {
	try {
		return await post(
			`${process.env.REACT_APP_API_URL}/CME/LeaveLine`,
			data
		);
	} catch (error) {
		customError.throwCustomError(
			error,
			customError.GENERIC_POST_ERROR_MESSAGE
		);
	}
};

export const deleteLeaveLineByFormId = async (data) => {
	try {
		return await post(
			`${process.env.REACT_APP_API_URL}/CME/LeaveLine/DeleteByFormId/${data.formId}`,
			null
		);
	} catch (error) {
		customError.throwCustomError(
			error,
			customError.GENERIC_POST_ERROR_MESSAGE
		);
	}
};

export const getRequestLinesByFormId = async (data) => {
	try {
		return await get(
			`${process.env.REACT_APP_API_URL}/CME/RequestLine/${data.formId}`
		);
	} catch (error) {
		customError.throwCustomError(error, customError.GENERIC_ERROR_MESSAGE);
	}
};

export const getRequestLinesByParentFormId = async (data) => {
	try {
		return await get(
			`${process.env.REACT_APP_API_URL}/CME/RequestLine/GetByParentFormId/${data.parentFormId}`
		);
	} catch (error) {
		customError.throwCustomError(error, customError.GENERIC_ERROR_MESSAGE);
	}
};

export const postRequestLines = async (data) => {
	try {
		return await post(
			`${process.env.REACT_APP_API_URL}/CME/RequestLine`,
			data
		);
	} catch (error) {
		customError.throwCustomError(
			error,
			customError.GENERIC_POST_ERROR_MESSAGE
		);
	}
};

export const getBalanceByPersonId = async (data) => {
	try {
		return await get(
			`${process.env.REACT_APP_API_URL}/CME/Balance/${data.personId}`
		);
	} catch (error) {
		customError.throwCustomError(error, customError.GENERIC_ERROR_MESSAGE);
	}
};

export const getOpenCommitmentByPersonId = async (data) => {
	try {
		return await get(
			`${process.env.REACT_APP_API_URL}/CME/OpenCommitment/${data.personId}`
		);
	} catch (error) {
		customError.throwCustomError(error, customError.GENERIC_ERROR_MESSAGE);
	}
};

export const getTransByPersonIdAndPeriodDate = async (data) => {
	try {
		return await get(
			`${process.env.REACT_APP_API_URL}/CME/Trans/${data.personId}/${data.periodDate}`
		);
	} catch (error) {
		customError.throwCustomError(error, customError.GENERIC_ERROR_MESSAGE);
	}
};

export const postTrans = async (data) => {
	try {
		return await post(`${process.env.REACT_APP_API_URL}/CME/Trans`, data);
	} catch (error) {
		customError.throwCustomError(
			error,
			customError.GENERIC_POST_ERROR_MESSAGE
		);
	}
};

export const getCPEEnrolmentByPersonId = async (data) => {
	try {
		return await get(
			`${process.env.REACT_APP_API_URL}/CME/CPEEnrolment/${data.personId}`
		);
	} catch (error) {
		customError.throwCustomError(error, customError.GENERIC_ERROR_MESSAGE);
	}
};

export const getCPECapHistoryByPersonId = async (data) => {
	try {
		return await get(
			`${process.env.REACT_APP_API_URL}/CME/CPEEnrolment/BalanceCap/${data.personId}`
		);
	} catch (error) {
		customError.throwCustomError(error, customError.GENERIC_ERROR_MESSAGE);
	}
};

export const deleteCPEEnrolmentById = async (id) => {
	try {
		return await post(
			`${process.env.REACT_APP_API_URL}/CME/CPEEnrolment/DeleteById/${id}`
		);
	} catch (error) {
		customError.throwCustomError(error, customError.GENERIC_ERROR_MESSAGE);
	}
};

export const processCPEEnrolmentUpdate = async (data) => {
	try {
		return await post(
			`${process.env.REACT_APP_API_URL}/CME/CPEEnrolment/ProcessCPEEnrolmentUpdate`,
			data
		);
	} catch (error) {
		customError.throwCustomError(
			error,
			customError.GENERIC_POST_ERROR_MESSAGE
		);
	}
};

export const getFormsByPersonId = async (data) => {
	try {
		return await get(
			`${process.env.REACT_APP_API_URL}/CME/Form/${data.personId}`
		);
	} catch (error) {
		customError.throwCustomError(error, customError.GENERIC_ERROR_MESSAGE);
	}
};

export const getSMOLeaveFormsByPersonId = async (data) => {
	try {
		return await get(
			`${process.env.REACT_APP_API_URL}/CME/Form/GetSMOLeaveFormsByPersonId/${data.personId}`
		);
	} catch (error) {
		customError.throwCustomError(error, customError.GENERIC_ERROR_MESSAGE);
	}
};

export const getActiveLeaveApplication = async (data) => {
	try {
		return await get(
			`${process.env.REACT_APP_API_URL}/CME/Form/GetActiveLeaveApplication/${data.minLeaveDate}/${data.teamId}`
		);
	} catch (error) {
		customError.throwCustomError(error, customError.GENERIC_ERROR_MESSAGE);
	}
};

export const updateFormStatus = async (data) => {
	try {
		return await post(
			`${process.env.REACT_APP_API_URL}/CME/Form/UpdateFormStatus/${data.formGuid}/${data.status}`
		);
	} catch (error) {
		customError.throwCustomError(
			error,
			customError.GENERIC_POST_ERROR_MESSAGE
		);
	}
};

export const updateFormIsRostered = async (data) => {
	try {
		return await post(
			`${process.env.REACT_APP_API_URL}/CME/Form/PostIsRostered/${data.formGuid}/${data.isRostered}`
		);
	} catch (error) {
		customError.throwCustomError(
			error,
			customError.GENERIC_POST_ERROR_MESSAGE
		);
	}
};

export const processLeaveRequest = async (data) => {
	try {
		return await post(
			`${process.env.REACT_APP_API_URL}/CME/Form/ProcessLeaveRequest/${data.formId}/${data.statusId}`
		);
	} catch (error) {
		customError.throwCustomError(
			error,
			customError.GENERIC_POST_ERROR_MESSAGE
		);
	}
};

export const rejectByPayroll = async (data) => {
	try {
		return await post(
			`${process.env.REACT_APP_API_URL}/CME/Form/RejectByPayroll/${data.formId}`
		);
	} catch (error) {
		customError.throwCustomError(
			error,
			customError.GENERIC_POST_ERROR_MESSAGE
		);
	}
};

export const rejectByCountiesFinance = async (data) => {
	try {
		return await post(
			`${process.env.REACT_APP_API_URL}/CME/Form/RejectByCountiesFinance`,
			data
		);
	} catch (error) {
		customError.throwCustomError(
			error,
			customError.GENERIC_POST_ERROR_MESSAGE
		);
	}
};

export const deleteForm = async (data) => {
	try {
		return await post(
			`${process.env.REACT_APP_API_URL}/CME/Form/Delete/${data.formGuid}`
		);
	} catch (error) {
		customError.throwCustomError(
			error,
			customError.GENERIC_POST_ERROR_MESSAGE
		);
	}
};

export const getFormApproval = async (data) => {
	try {
		const {
			approverId,
			personId,
			workflowWaitingOnId,
			formTypeId,
			includeHistory,
		} = data;

		return await get(
			`${process.env.REACT_APP_API_URL}/CME/FormApproval/${approverId}/${personId}/${workflowWaitingOnId}/${formTypeId}/${includeHistory}`
		);
	} catch (error) {
		customError.throwCustomError(error, customError.GENERIC_ERROR_MESSAGE);
	}
};

export const getLeaveReport = async (data) => {
	try {
		const { leaveFrom, leaveTo } = data;

		var fromParam = leaveFrom ? "leaveFrom=" + leaveFrom : null;
		var toParam = leaveTo ? "leaveTo=" + leaveTo : null;
		var params = [fromParam, toParam].filter(Boolean).join("&");

		return await get(
			`${process.env.REACT_APP_API_URL}/CME/CPEForm/LeaveReport${
				params ? "?" + params : ""
			}`
		);
	} catch (error) {
		customError.throwCustomError(error, customError.GENERIC_ERROR_MESSAGE);
	}
};

export const getPayrollForms = async (personId) => {
	try {
		return await get(
			`${process.env.REACT_APP_API_URL}/CME/Form/GetPayrollForms/${personId}`
		);
	} catch (error) {
		customError.throwCustomError(
			error,
			customError.GENERIC_POST_ERROR_MESSAGE
		);
	}
};

//End of CME apis

//#region Workflow approval apis

export const migrate = async (data) => {
	try {
		const { userId, migrateUserId, organisationHierarchyId } = data;
		return await post(`${process.env.REACT_APP_API_URL}/Workflow/Migrate`, {
			oldUserId: userId,
			newUserId: migrateUserId,
			organisationHierarchyId,
		});
	} catch (error) {
		customError.throwCustomError(error, customError.GENERIC_ERROR_MESSAGE);
	}
};

export const getMigrationPendingWorkflows = async (data) => {
	try {
		const { userId, organisationHierarchyId } = data;
		return await post(
			`${process.env.REACT_APP_API_URL}/Workflow/PendingWorkflows`,
			{
				userId,
				organisationHierarchyId,
			}
		);
	} catch (error) {
		customError.throwCustomError(error, customError.GENERIC_ERROR_MESSAGE);
	}
};

//#endregion

//#region Mileage rate apis
export const postMileageRates = async (data) => {
	try {
		return await post(
			`${process.env.REACT_APP_API_URL}/CME/MileageRate`,
			data
		);
	} catch (error) {
		customError.throwCustomError(error, customError.GENERIC_ERROR_MESSAGE);
	}
};

export const getMileageRates = async () => {
	try {
		return await get(`${process.env.REACT_APP_API_URL}/CME/MileageRate`);
	} catch (error) {
		customError.throwCustomError(error, customError.GENERIC_ERROR_MESSAGE);
	}
};
//#endregion

export const postDeleteForm = async (id) => {
	try {
		return await post(
			`${process.env.REACT_APP_API_URL}/ResponseForm/DeleteForm/${id}`,
			null
		);
	} catch (error) {
		customError.throwCustomError(
			error,
			customError.GENERIC_POST_ERROR_MESSAGE
		);
	}
};

export const getPreviousItClaim = async ({
	categoryLookupId,
	personId,
	excludeFormId,
	invoiceDate,
}) => {
	try {
		return await get(
			`${process.env.REACT_APP_API_URL}/CME/Form/GetPreviousITClaim/${categoryLookupId}/${personId}/${excludeFormId}/${invoiceDate}`
		);
	} catch (error) {
		customError.throwCustomError(error, customError.GENERIC_ERROR_MESSAGE);
	}
};
